class Paginator {
    constructor() {
        this.currentPage = 1
    }

    pagingAction(page) {
        this.onChange({$page: page})
    }
}

angular.module('eficienciaFiscalModule')
    .component('paginator', {
        controller: [Paginator],
        bindings: {
            perPage: '<',
            total: '<',
            currentPage: '=',
            onChange: '&'
        },
        //language=HTML
        template: `
            <div class="text-center pagination-slim" ng-hide="$ctrl.total <= $ctrl.perPage">
                <paging page="$ctrl.currentPage" page-size="$ctrl.perPage"
                        total="$ctrl.total" paging-action="$ctrl.pagingAction(page)" 
                        ul-class="pagination" adjacent="2" show-prev-next="true"></paging>
            </div>
        `
    })
